const SESSION_KEY = 'dhh_collab_recording_audio_check_passed';

export function isRecordingAudioCheckPassed(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setRecordingAudioCheckPassed(): void {
  try {
    sessionStorage.setItem(SESSION_KEY, 'true');
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearRecordingAudioCheckPassed(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}
